// DESIGN-REVIEW GALLERY (demo-only, no nav entry; reachable at /gallery).
//
// Renders the real My Work Plan presentation (CaseFamilies) over REAL prod
// work-plan shapes, one per edge-case archetype that exists in the data:
// orphan activities, unlinked plans, blank goals, appointment rows, replaced
// twins, dual-family, zero-goal outliers, and the empty state. Fixture data
// is PII-scrubbed (alias names/case numbers; hours, codes, statuses, dates,
// and linkage patterns untouched). Regenerate fixtures with
// `tools/gallery-data.mjs` (creds from the my-case lambda config).
import planGallery from "../__fixtures__/planGallery";
import {CaseFamilies} from "./MyCaseDashboard";

const DHW_BLUE = "#001489";

const MyCaseGallery = () => (
  <div
    data-testid="mycase-gallery"
    className="min-h-full bg-white pb-10 font-sans"
  >
    <div className="mb-8">
      <h2 className="text-2xl font-bold text-[#191919]">
        Work plan gallery{" "}
        <span className="text-base font-semibold text-slate-500">
          (design review: real data shapes, scrubbed names)
        </span>
      </h2>
      <p className="mt-1 text-base text-slate-600">
        {planGallery.length} real participant work-plan shapes from prod, one
        per edge case that currently exists in the data, rendered with the
        production components. Not participant-facing.
      </p>
    </div>
    <div className="space-y-12">
      {planGallery.map((fixture, i) => (
        <section key={i}>
          <h3
            className="mb-1 border-b pb-2 text-sm font-black uppercase tracking-wide"
            style={{color: DHW_BLUE, borderColor: "#CBD3F0"}}
          >
            {i + 1}. {fixture.label}{" "}
            <span className="font-semibold text-slate-400">
              ({fixture.matchCount} of {fixture.totalParticipants} people,{" "}
              {fixture.matchPct}% of all; {fixture.plannedCount} of{" "}
              {fixture.plannedTotal} with a plan, {fixture.plannedPct}%)
            </span>
            {fixture.dataNote && (
              <span
                className="ml-2 rounded-full px-2 py-0.5 text-xs font-bold normal-case tracking-normal"
                style={{
                  backgroundColor:
                    fixture.dataNote.side === "crm" ? "#FFF3E3" : "#EEF1FB",
                  color:
                    fixture.dataNote.side === "crm" ? "#9A5300" : "#001489",
                }}
              >
                {fixture.dataNote.side === "crm"
                  ? "CRM data gap (not ours)"
                  : "portal-side gap"}
              </span>
            )}
          </h3>
          {fixture.dataNote && (
            <p className="mb-3 text-xs text-slate-500">
              {fixture.dataNote.text}
            </p>
          )}
          {fixture.data.referrals.length > 0 ? (
            <CaseFamilies referrals={fixture.data.referrals} />
          ) : (
            <p className="text-sm text-slate-500">No open referrals.</p>
          )}
        </section>
      ))}
    </div>
  </div>
);

export default MyCaseGallery;
